export default __webpack_public_path__ + "static/media/introduce-vbee-edu.aa66b680.svg";